const FUNNEL_WEB_BASE = '/funnel';

export const isFunnelPath = (pathname: string): boolean =>
  pathname === FUNNEL_WEB_BASE || pathname.startsWith(`${FUNNEL_WEB_BASE}/`);
